// https://vuex.vuejs.org/en/actions.html

import resellerProfileService from '@/services/resellerProfileService'
import store from '@/store'

export default {
  async UpdateResellerProfile (context, reseller, loadingMessage) {
    var loadingId = await store.dispatch('AddLoadingMessage', loadingMessage)
    var apiResult = await resellerProfileService.updateReseller(reseller)
    if (apiResult.success) {
      context.commit('updateReseller', apiResult.value)
    }
    store.dispatch('RemoveLoadingMessage', loadingId)
    return apiResult
  },
}
